(function () {
    'use strict';

    angular.module('app.services', ['smart-table', 'treeControl', 'ui.bootstrap', 'ui.grid', 'ui.grid.pagination']);
})();